export default __webpack_public_path__ + "static/media/icon-add-user-circle-outline.0f75bc59.svg";